import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { Input } from "@workspace/web-ui/components/input";
import { Label } from "@workspace/web-ui/components/label";

import { WelcomeFormSchema } from "../schema";
import { InputField } from "../types";
import { FormContainer, WelcomeStepFormProps } from "./form-container";

export function TakenGlpStep({ data, updateFields }: WelcomeStepFormProps) {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<WelcomeFormSchema>();

  const recentdoseValue = watch("recentdose");
  const lastintakeValue = watch("lastintake");

  useEffect(() => {
    updateFields({
      recentdose: recentdoseValue,
      lastintake: lastintakeValue,
    });
  }, [recentdoseValue, lastintakeValue, updateFields]);

  return (
    <FormContainer heading={data.heading} description={data.description}>
      {data.form &&
        (data.form as InputField[]).map((form) => {
          const name = form.name as keyof WelcomeFormSchema;

          const { label, type, placeholder } = form;
          if (name === "recentdose") {
            return (
                <div className="w-full space-y-2" key={label}>
                  <Label
                    htmlFor={label}
                    className="mb-4 flex self-start text-left text-lg text-[#7F8493] transition-colors duration-200 ease-in-out peer-checked:text-[#363840]"
                  >
                    {label}
                  </Label>
                  <div className="flex w-full rounded-2xl shadow-sm shadow-black/5">
                    <Input
                      id={label}
                      placeholder={placeholder}
                      type={type}
                      className="peer -me-px h-[40px] w-11/12 rounded-s-2xl rounded-e-none p-4 shadow-none sm:h-[60px] lg:h-[80px] lg:w-11/12"
                      {...register(name as keyof WelcomeFormSchema)}
                    />
                    {name === "recentdose" && (
                      <span className="z-10 inline-flex items-center rounded-e-2xl border border-input px-3 text-sm text-[#363840]">
                        MG
                      </span>
                    )}
                  </div>
                  {name === "recentdose" && errors.recentdose && (
                    <p className="text-sm text-[#7F8493]">
                      <p className="text-sm text-red-500">
                        {errors.recentdose.message}
                      </p>
                    </p>
                  )}
                </div>
              );
          }

          return (
            <div className="w-full space-y-2" key={label}>
              <Label
                htmlFor={label}
                className="mb-4 flex self-start w-full text-left text-lg text-[#7F8493] transition-colors duration-200 ease-in-out peer-checked:text-[#363840]"
              >
                {label}
              </Label>
              <div className="flex w-full rounded-lg shadow-sm shadow-black/5">
                <Input
                  id={label}
                  placeholder={placeholder}
                  type={type}
                  className="peer -me-px h-[40px] w-full rounded-2xl p-4 shadow-none sm:h-[60px] lg:h-[80px] lg:w-full"
                  {...register(name as keyof WelcomeFormSchema)}
                />
              </div>
              {name === "lastintake" && errors.lastintake && (
                <p className="text-sm text-[#7F8493]">
                  <p className="text-sm text-red-500">
                    {errors.lastintake.message}
                  </p>
                </p>
              )}
            </div>
          );


        })}
    </FormContainer>
  );
}
